// export const Category_Surgeries = '387713003';
// export const Category_SurgicalHistory = '387713003';
export const Category_SurgeriesAndSurgicalHistory = '387713003';
export const FHIR_Procedure_CategoryOptions = [
    Category_SurgeriesAndSurgicalHistory
];
export const FHIR_Procedure_CategoryOptions_ToLabelsMap = {
    [Category_SurgeriesAndSurgicalHistory]: 'Surgeries / Surgical History',
};
//# sourceMappingURL=consts.js.map